import script from "./GradeNextPageChapter.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeNextPageChapter.vue?vue&type=script&setup=true&lang=js"

import "./GradeNextPageChapter.vue?vue&type=style&index=0&id=6fb2e708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb2e708"]])

export default __exports__